var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useMutation, useQuery } from '@apollo/client';
import get from 'lodash/get';
import { useSnackbar } from 'notistack';
import { useDrawer } from 'context/DrawerContext';
import sharedMessages from 'translations/shared';
import { track, SegmentTrackableEnum } from 'factory/SegmentFactory';
import updateWebinarMutation from './updateWebinar.graphql';
import updateWebinarSessionMutation from './updateWebinarSession.graphql';
import query from './query.graphql';
import View from './View';
var Container = function (props) {
    var onError = props.onError, onSuccess = props.onSuccess, id = props.id;
    var closeDrawer = useDrawer().closeDrawer;
    var queryResponse = useQuery(query, {
        variables: {
            input: {
                id: id,
            },
            locationInput: {
                limit: 1000,
                offset: 0,
            },
        },
    });
    var _a = __read(useState(), 2), onUpdateState = _a[0], setOnUpdateState = _a[1];
    var _b = __read(useState(), 2), onUpdateSessionState = _b[0], setOnUpdateSessionState = _b[1];
    var formatMessage = useIntl().formatMessage;
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var _c = __read(useMutation(updateWebinarSessionMutation, {
        onCompleted: function (data) {
            if (onSuccess)
                onSuccess(data.editWebinarSession);
            enqueueSnackbar(formatMessage(sharedMessages.updatedWebinar), {
                variant: 'success',
            });
        },
        onError: function (error) {
            enqueueSnackbar(error.message, { variant: 'error' });
            if (onError)
                onError(error);
        },
    }), 2), updateWebinarSession = _c[0], updateSessionResult = _c[1];
    var onUpdateSession = function (input) {
        updateWebinarSession({
            variables: {
                input: input,
            },
        });
    };
    var _d = __read(useMutation(updateWebinarMutation, {
        onCompleted: function (data) {
            if (onSuccess)
                onSuccess(data.editWebinar);
            track(SegmentTrackableEnum.WEBINAR_UPDATED, __assign({}, data));
            closeDrawer();
            if (!onUpdateSessionState)
                return;
            var updateSession = __assign(__assign({}, onUpdateSessionState), { webinarId: data.updateWebinar.id });
            onUpdateSession(updateSession);
        },
        onError: function (error) {
            enqueueSnackbar(error.message, { variant: 'error' });
            if (onError)
                onError(error);
        },
    }), 2), updateWebinar = _d[0], updateResult = _d[1];
    var onUpdate = function (input) {
        updateWebinar({
            variables: {
                input: input,
            },
        });
    };
    useEffect(function () {
        if (!onUpdateState)
            return;
        onUpdate(onUpdateState);
    }, [onUpdateState]);
    return (_jsx(View, { onUpdateState: setOnUpdateState, onUpdateSessionState: setOnUpdateSessionState, error: updateResult.error || queryResponse.error, isProcessing: updateResult.loading, isLoading: queryResponse.loading, webinarSession: get(queryResponse, 'data.getWebinarSession') }, void 0));
};
export default Container;
